import React, { FC, useEffect } from 'react';

import Modal from '~components/atoms/Modal';

import CreateStockOutForm from '../CreateStockOutForm';
import { useAppDispatch } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';

type CreateStockOutModalProps = {
    isOpen: boolean;
    onClose: () => void;
}

const CreateStockOutModal: FC<CreateStockOutModalProps> = ({
    isOpen,
    onClose,
}) => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!isOpen) {
            dispatch(combinedActions.goldClearCreateStockOutParams());
        }
    }, [isOpen, dispatch]);

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title='Create Stock Out'
        >
            <CreateStockOutForm />
        </Modal>
    );
};

export default CreateStockOutModal;
